<template>
    <index-table-row :item="item">
        <index-table-cell v-text="item.name"/>
        <index-table-cell v-text="item.subdomain"/>
        <index-table-cell v-text="item.email"/>
        <index-table-cell-bool :bool="Boolean(item.active)"/>
        <index-table-cell>
            <reseller-more-dropdown :reseller="itemData"/>
        </index-table-cell>
    </index-table-row>
</template>

<script>
    import IndexTableRow from "../../components/Index/IndexTableRow";
    import IndexTableCell from "../../components/Index/IndexTableCell";
    import ResellerMoreDropdown from "./ResellerMoreDropdown";
    import IndexTableCellBool from "../../components/Index/IndexTableCellBool";

    export default {
        name: "ResellersRow",
        components: {IndexTableCellBool, ResellerMoreDropdown, IndexTableCell, IndexTableRow},
        props: {
            item: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                itemData: this.item,
            }
        },
        watch: {
            item(value) {
                this.itemData = value;
            }
        }
    }
</script>

<style lang="scss">
    .app-action {
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 27px;
        width: 80px;

        .app-action-btn {
            display: none !important;
        }

        &:hover {
            .md-icon {
                display: none;
            }

            .app-action-btn {
                display: inline-block !important;
                width: auto !important;
            }
        }
    }
</style>